import React from 'react';

import Typography from '../../library/typography/typography';

import './product-warranty.scss';

interface ProductWarrantyProps {
  className?: string;
  miles: string | number | null;
  size?: string;
}

function ProductWarranty(props: ProductWarrantyProps) {
  const { className, miles, size } = props;

  if (!miles || Number(miles) === 0) {
    return null;
  }

  return (
    <Typography
      className={className}
      size={size}
      styleName="warranty"
      tag="span"
    >{`${miles} mile warranty`}</Typography>
  );
}

export default ProductWarranty;
